import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ReactJson from 'react-json-view'

import TrackingTable from './TrackingTable'
import { fetchData } from '../../../common/redux/collectionActions'

type Props = {
  isActive: Boolean,
  isLoading: Boolean,
}

const nameAccessor = (d) => d.custom_name || null
const controllerAccessor = (d, controllers) => controllers.find((c) => c._id === d.controller)

const Cell = (d) => d.value || null

const LockTracking = ({ isActive, isLoading }: Props) => {
  const locks = useSelector((s) => s.collectionData.locks)
  const controllers = useSelector((s) => s.collectionData.controllers)

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchData(['controllers', 'drivers']))
  }, [dispatch])

  if (!isActive) return null

  return (
    <TrackingTable
      isLoading={isLoading}
      columns={[
        {
          Header: 'Namn:',
          id: 'name',
          accessor: nameAccessor,
          Cell,
        },
        {
          Header: 'Public key:',
          id: 'public_key',
          accessor: (d) => controllerAccessor(d, controllers),
          Cell: (d) => (d.value ? d.value.public_key || null : null),
        },
        {
          Header: 'Data:',
          id: 'data',
          accessor: (d) => controllerAccessor(d, controllers),
          // eslint-disable-next-line react/display-name
          Cell: (d) =>
            (d.value ? (
              <ReactJson
                collapsed
                displayDataTypes={false}
                name={false}
                displayObjectSize={false}
                src={{
                  open_duration: d.value.open_duration,
                  created: d.value.created,
                  hardware_functions: d.value.hardware_functions,
                }}
              />
            ) : null),
        },
      ]}
      data={locks}
    />
  )
}

export default LockTracking
